export default __webpack_public_path__ + "static/media/logo_damf.77903d9d.png";